/**
 * TruWe Kids page copy. Key prefix: "kids."
 */
export const kids = {
  en: {
    "kids.topbar.happy": "HAPPY KIDS.",
    "kids.topbar.healthy": "HEALTHY FUTURE.",

    "kids.hero.badge": "A whole new world",
    "kids.hero.heading.happy": "Happy Kids.",
    "kids.hero.heading.healthy": "Healthy ",
    "kids.hero.heading.future": "Future.",
    "kids.hero.desc": "TruWe Kids combines clean ingredients with fun, friendly nutrition to support growing kids. Scientifically backed. Parent trusted. Made for happy, healthy kids.",
    "kids.hero.launchingSoon": "Launching soon",
    "kids.hero.whyBtn": "Why TruWe Kids",
    "kids.hero.imgAlt": "Captain TruWe. TruWe Kids koala mascot climbing a rope through the jungle",
    "kids.hero.comingYear": "Coming 2026",
    "kids.hero.noAddedSugar": "No added sugar 🌱",

    "kids.values.eyebrow": "Our brand values",
    "kids.values.heading.pre": "Nutrition made ",
    "kids.values.heading.safe": "safe",
    "kids.values.heading.mid1": ", ",
    "kids.values.heading.tasty": "tasty",
    "kids.values.heading.mid2": " & ",
    "kids.values.heading.effective": "effective",
    "kids.values.heading.end": ".",

    "kids.value.safe.title": "Safe & Trusted",
    "kids.value.safe.desc": "Made with safety and quality as our promise.",
    "kids.value.clean.title": "Clean Nutrition",
    "kids.value.clean.desc": "High-quality ingredients with no unnecessary additives.",
    "kids.value.made.title": "Made for Kids",
    "kids.value.made.desc": "Thoughtfully formulated for growing bodies and minds.",
    "kids.value.every.title": "For Every Child",
    "kids.value.every.desc": "Nutrition that supports every child's unique journey.",

    "kids.launch.badge": "Launching soon",
    "kids.launch.heading.pre": "Something ",
    "kids.launch.heading.tasty": "tasty",
    "kids.launch.heading.mid": " is ",
    "kids.launch.heading.coming": "coming",
    "kids.launch.heading.end": ".",
    "kids.launch.desc": "We're putting the finishing touches on the TruWe Kids gummies range, clean, science-backed nutrition designed for happy, healthy kids. Be the first to know when we launch.",
    "kids.launch.noSpam": "No spam, just a launch announcement.",

    "kids.promise.eyebrow": "Our promise",
    "kids.promise.heading": "Happy Kids. Healthy Future.",
    "kids.promise.line": "Safe & Trusted · Clean Nutrition · Made for Kids · For Every Child.",
    "kids.promise.shopBtn": "Shop the range",

    "kids.suggest.badge": "Parents' wishlist",
    "kids.suggest.heading": "Tell us what your kid needs next.",
    "kids.suggest.desc": "We build TruWe Kids with parents, not for them. Suggest a product, nutrient, or format you'd love us to launch, every idea reaches our formulation team.",
    "kids.suggest.point1": "Reviewed by our clinical & formulation team",
    "kids.suggest.point2": "Best-voted ideas get early access & discounts",

    "kids.related.heading": "Explore more from TruWe",
    "kids.related.kidsNutrition": "Kids nutrition",
    "kids.related.magnesium": "Magnesium supplements",
    "kids.related.sleep": "Sleep & recovery",
    "kids.related.inositol": "Inositol supplements",
    "kids.related.pcos": "PCOS nutrition",
    "kids.related.liverGut": "Liver & gut support",

    "kids.form.suggest.ideaLabel": "What product would you love? *",
    "kids.form.suggest.ideaPlaceholder": "e.g. Immunity gummies with elderberry",
    "kids.form.suggest.reasonLabel": "Why does your kid need it?",
    "kids.form.suggest.reasonPlaceholder": "Tell us the concern, routine, or gap you're trying to fill…",
    "kids.form.suggest.ageLabel": "Child's age",
    "kids.form.suggest.namePlaceholder": "Your name (optional)",
    "kids.form.suggest.emailPlaceholder": "Email (optional)",
    "kids.form.suggest.submitBtn": "Submit my idea",
    "kids.form.suggest.submitting": "Sending...",
    "kids.form.suggest.disclaimer": "We'll only reach out about your suggestion. No marketing spam.",
    "kids.form.suggest.errIdea": "Please describe your product idea",
    "kids.form.suggest.errEmail": "Please enter a valid email address",
    "kids.form.suggest.errGeneric": "Something went wrong. Please try again.",
    "kids.form.suggest.toastSuccess": "Idea received! Thank you 💛",
    "kids.form.suggest.doneHeading": "Idea received 💛",
    "kids.form.suggest.doneDesc": "Our formulation team reviews every parent suggestion. We'll email you if it makes the roadmap.",
    "kids.form.suggest.suggestAnother": "Suggest another",

    "kids.form.notify.emailLabel": "Email address",
    "kids.form.notify.emailPlaceholder": "Your email",
    "kids.form.notify.phoneLabel": "Mobile number",
    "kids.form.notify.phonePlaceholder": "Mobile number (10 digits)",
    "kids.form.notify.submitBtn": "Notify me at launch",
    "kids.form.notify.submitting": "Saving...",
    "kids.form.notify.errEmail": "Please enter a valid email address",
    "kids.form.notify.errPhone": "Please enter a valid 10-digit mobile number",
    "kids.form.notify.errGeneric": "Something went wrong. Please try again.",
    "kids.form.notify.toastAlready": "You're already on the list! 🌟",
    "kids.form.notify.toastSuccess": "You're on the list! We'll be in touch soon. 🌟",
    "kids.form.notify.doneHeading": "You're on the list! 🌟",
    "kids.form.notify.doneDesc": "We'll ping you the moment TruWe Kids launches.",
  },
} as const;
